import React, { useState, useEffect } from 'react';
import MyGoal from '../../components/MyGoal';
import { Goal, Evaluation } from '../../service/PerformanceAPI';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import ManagerGoal from '../../components/ManagerGoal';
import OrganizationGoal from '../OrganizationGoal/OrganizationGoal';
import EvaluationPopUp from '../../components/EvaluationPopUp';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import Loader from '../../StaticComponent/Loader';
import { encryptStorage } from '../../constant'

// import './Performance.css'

export default function Performance() {
    const { state } = useLocation()
    const navigate = useNavigate();

    let details = { role: '', roleId: '', domain: '' };
    const [userDetails, setUserDetails] = useState(details);
    const [tabClicked, setTabClicked] = useState('');
    const [individualGoal, setIndividualGoal] = useState([]);
    const [teamGoal, setTeamGoal] = useState([]);
    const [evaluationPeriod, setEvaluationPeriod] = useState([]);
    const [evaluationIndex, setEvaluationIndex] = useState([]);
    const [evaluationShow, setEvaluationShow] = useState({});
    const [evaluationId, setEvaluationId] = useState({});
    const [individualEvaluation, setIndividualEvaluation] = useState([]);
    const [managerEvaluationPopUp, setmanagerEvaluationPopUp] = useState(false);
    const [HrEvaluationPopUp, setHrEvaluationPopUp] = useState(false);
    const [breadCrumbsData, setbreadCrumbsData] = useState([]);
    const [HrEvaluationHeading, setHrEvaluationHeading] = useState('');
    const [managerEvaluationHeading, setmanagerEvaluationHeading] = useState('');
    const [EvaluationImage, setEvaluationImage] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [customStartEvaluation, setcustomStartEvaluation] = useState(false);

    const [insertToast, setinsertToast] = useState(false);
    const [ToastColor, setToastColor] = useState('');
    const [ToastPara, setToastPara] = useState('');
    const [ToastValue, setToastValue] = useState('');
    const location = useLocation();
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);

    useEffect(() => {
        if (location.state?.showSuccessPopup) {
            setShowSuccessPopup(true);
            setTimeout(() => {
                setShowSuccessPopup(false);
            }, 2000);
        }
    }, [location]);
    useEffect(() => {
        let toastCheck = sessionStorage.getItem('goalData')
        if (toastCheck == 'inserted' || toastCheck == 'updated') {
            setToastColor('green')
            if (toastCheck == 'inserted') {
                setToastPara('Goal Evaluation submitted')
                setToastValue('Successfully Submitted')
            }
            if (toastCheck == 'updated') {
                setToastPara('Goal Evaluation updated')
                setToastValue('Successfully Updated')
            }
            setinsertToast(true)
            sessionStorage.removeItem('goalData')
        }

        setIsLoading(false)
        userDetails.roleId = encryptStorage.getItem('employeeId');
        userDetails.role = encryptStorage.getItem('role') === 'Hr' ? 'Hr Manager' : encryptStorage.getItem('role');
        // userDetails.role = encryptStorage.getItem('role') ;
        userDetails.domain = encryptStorage.getItem('department');
        evaluationData();
    }, []);

    useEffect(() => {
        if (state?.tab == 'orggoal') {
            setTabClicked(state?.tab)
            if (userDetails.role == 'Hr Manager') {
                HrManagerStartEvaluation()
            }
            else if (userDetails.role == 'Manager') {
                ManagerStartEvaluationCheck()
            }
        }
    }, [state?.tab])



    const evaluationData = async () => {
        let evaluation_id;
        let res = await Evaluation();
        ////
        if (res.data.ResponseData.length > 0) {
            setEvaluationPeriod(res.data.ResponseData);
            res.data.ResponseData.map((result, i) => {
                if (result.currentEvaluation == '1') {
                    setEvaluationIndex(i);
                    setEvaluationShow(result);
                    evaluation_id = result.id;
                    setEvaluationId(result.id);
                }
            });

            setIsLoading(true)

            loadGoalData(evaluation_id);
        }
        setbreadCrumbsData(
            userDetails.role == 'Team Member'
                ? [
                    { title: 'Dashboard', path: '/Overview', isActive: true },
                    { title: 'My Performance', path: '', isActive: true },
                    { title: 'Performance', path: '/performance', isActive: false },
                ]
                : [
                    { title: 'Dashboard', path: '/Overview', isActive: true },
                    { title: 'Team Member', path: '', isActive: true },
                    { title: 'Performance', path: '/performance', isActive: false },
                ]
        );
    };

    const loadGoalData = async (id) => {
        setIsLoading(false)
        let goalData = {
            employeeId: userDetails.roleId,
            evaluation_period_id: id,
            domain: userDetails.domain,
        };
        let result = await Goal(goalData);
        setIndividualGoal(result.data.ResponseData.individual);
        setTeamGoal(result.data.ResponseData.team);
        setIndividualEvaluation(result.data.Evaluation);

        setIsLoading(true)
    };

    const previousEvaluation = async (value) => {
        let currentIndex = evaluationIndex;


        if (currentIndex == 0) {
            currentIndex = evaluationPeriod.length - 1;
            setEvaluationIndex(currentIndex);
            setEvaluationShow(evaluationPeriod[currentIndex]);
        } else {
            currentIndex -= 1;
            setEvaluationIndex(currentIndex);
            setEvaluationShow(evaluationPeriod[currentIndex]);
        }
        loadGoalData(evaluationPeriod[currentIndex].id);
    };

    const nextEvaluation = async (value) => {
        let currentIndex = evaluationIndex;



        if (currentIndex == evaluationPeriod.length - 1) {
            currentIndex = 0;
            setEvaluationIndex(currentIndex);
            setEvaluationShow(evaluationPeriod[currentIndex]);
        } else if (value == 'next') {
            currentIndex += 1;
            setEvaluationIndex(currentIndex);
            setEvaluationShow(evaluationPeriod[currentIndex]);
        }
        loadGoalData(evaluationPeriod[currentIndex].id);
    };

    const AssgignGoal = (type) => {
        navigate('/goaltemplate', { state: { type: type } });
    };

    const checkPopUp = (roleCheck, dayCheck, IdCheck, stateSet) => {
        //

        let check = (roleCheck === 'Hr Manager' && dayCheck === 9) ? setHrEvaluationHeading('Hr Manager Evaluation period will be starting in 2 days.') :
            (roleCheck === 'Hr Manager' && dayCheck === 7) ? setHrEvaluationHeading('Hr Manager Evaluation is started.') : null

        check = (roleCheck === 'Manager' && dayCheck === 16) ? setmanagerEvaluationHeading('Manager Evaluation period will be starting in 2 days.') :
            (roleCheck === 'Manager' && dayCheck === 14) ? setmanagerEvaluationHeading('Manager Evaluation is started.Please provide your evaluation right now') : null

        check = (dayCheck === 9 || dayCheck === 16) ? setEvaluationImage('Honeybee.svg') : setEvaluationImage('Evaluation-started.svg')

        if (userDetails.role == roleCheck && evaluationShow?.endDate) {
            //

            if (evaluationShow.id == encryptStorage.getItem('CurrentEvaluationId')) {
                let endDate = moment(evaluationShow.endDate).subtract(dayCheck, 'days').format('MM-DD-YY');

                if (moment().format('MM-DD-YY') === endDate) {
                    let started = encryptStorage.getItem(IdCheck);
                    if (started == null || started == undefined && (started !== true)) {
                        stateSet(true);
                    }
                }
            }
        }
    }



    const ManagerStartEvaluationCheck = () => {
        setTabClicked('orggoal')
        let endDate = moment(evaluationShow.endDate).subtract(16, 'days').format('MM-DD-YY');
        if (moment().format('MM-DD-YY') === endDate) {
            checkPopUp('Manager', 16, 'EvaluationStartedManager', setmanagerEvaluationPopUp);
        }
        else {
            let endDate = moment(evaluationShow.endDate).subtract(14, 'days').format('MM-DD-YY');
            if (moment().format('MM-DD-YY') === endDate) {
                setcustomStartEvaluation(true)
                checkPopUp('Manager', 14, 'EvaluationStartedManager', setmanagerEvaluationPopUp);
            }
            else if (moment().format('MM-DD-YY') > endDate) {
                setcustomStartEvaluation(true)
            }
        }
    }

    const HrManagerStartEvaluation = () => {
        setTabClicked('orggoal')
        let endDate = moment(evaluationShow.endDate).subtract(9, 'days').format('MM-DD-YY');
        if (moment().format('MM-DD-YY') === endDate) {
            checkPopUp('Hr Manager', 9, 'EvaluationStartedHrManager', setHrEvaluationPopUp);
        }
        else {
            let endDate = moment(evaluationShow.endDate).subtract(7, 'days').format('MM-DD-YY');
            if (moment().format('MM-DD-YY') === endDate) {
                setcustomStartEvaluation(true)
                checkPopUp('Hr Manager', 7, 'EvaluationStartedHrManager', setHrEvaluationPopUp);
            }
            else if (moment().format('MM-DD-YY') > endDate) {
                setcustomStartEvaluation(true)
            }
        }
    }

    return (
        <>
         {showSuccessPopup && (
                <EvaluationPopUp
                    color="green"
                    Page="Success Insert"
                    Heading="Submitted Successfully"
                    Paragraph="Goal Evaluation submitted"
                />
            )}
            {HrEvaluationPopUp ? <EvaluationPopUp Image={EvaluationImage} ID={'EvaluationStartedHrManager'} Page={'button'} Heading={HrEvaluationHeading} /> : null}
            {managerEvaluationPopUp ? <EvaluationPopUp Image={EvaluationImage} ID={'EvaluationStartedManager'} Page={'button'} Heading={managerEvaluationHeading} /> : null}
            {insertToast ? (
                <EvaluationPopUp color={ToastColor} Page={'Success Insert'} Heading={ToastValue} Paragraph={ToastPara} />
            ) : null}
            {isLoading ?
                <div className="container-fluid mt-5">
                    <div className="row">
                        <div className="col-md-12 px-4">
                            {/*goal tab starts here*/}
                            <div className="mt-4" style={{ "margin-left": "0px" }}>
                                <BreadCrumbs data={breadCrumbsData} />
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                                <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button onClick={() => { setTabClicked('mygoal') }}
                                            className={tabClicked === 'mygoal' || tabClicked === '' ? "nav-link px-0 active font-15 tab-style bold-text rounded-0" : "nav-link px-0 font-15 tab-style bold-text rounded-0"}
                                            id="mygoal-tab"
                                            data-bs-toggle="pill"
                                            data-bs-target="#mygoal"
                                            type="button"
                                            role="tab"
                                            aria-controls="mygoal"
                                            aria-selected="true"
                                        >
                                            My Goals
                                        </button>
                                    </li>
                                    {userDetails.role != 'Manager' && userDetails.role != 'Hr Manager' ? null : userDetails.role ==
                                        'Manager' ? (
                                        <li className="nav-item ms-5" role="presentation">
                                            <button
                                                onClick={() => {
                                                    //
                                                    ManagerStartEvaluationCheck()
                                                    // setTabClicked('orggoal')
                                                    // let endDate = moment(evaluationShow.endDate).subtract(16, 'days').format('MM-DD-YY');
                                                    // if (moment().format('MM-DD-YY') === endDate) {
                                                    //     checkPopUp('Manager', 16, 'EvaluationStartedManager', setmanagerEvaluationPopUp);
                                                    // }
                                                    // else {
                                                    //     let endDate = moment(evaluationShow.endDate).subtract(14, 'days').format('MM-DD-YY');
                                                    //     if (moment().format('MM-DD-YY') === endDate) {
                                                    //         setcustomStartEvaluation(true)
                                                    //         checkPopUp('Manager', 14, 'EvaluationStartedManager', setmanagerEvaluationPopUp);
                                                    //     }
                                                    //     else if (moment().format('MM-DD-YY') > endDate) {
                                                    //         setcustomStartEvaluation(true)
                                                    //     }
                                                    // }
                                                }}
                                                className={tabClicked === 'orggoal' ? "nav-link px-0 active font-15 tab-style bold-text rounded-0" : "nav-link px-0 font-15 tab-style bold-text rounded-0"}

                                                id="orggoal-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#orggoal"
                                                type="button"
                                                role="tab"
                                                aria-controls="orggoal"
                                                aria-selected="false"
                                            >
                                                Team Member Goal
                                            </button>
                                        </li>
                                    ) : (
                                        <li className="nav-item ms-5" role="presentation">
                                            <button
                                                onClick={() => {
                                                    //
                                                    HrManagerStartEvaluation()
                                                    // setTabClicked('orggoal')
                                                    // let endDate = moment(evaluationShow.endDate).subtract(9, 'days').format('MM-DD-YY');
                                                    // if (moment().format('MM-DD-YY') === endDate) {
                                                    //     checkPopUp('Hr Manager', 9, 'EvaluationStartedHrManager', setHrEvaluationPopUp);
                                                    // }
                                                    // else {
                                                    //     let endDate = moment(evaluationShow.endDate).subtract(7, 'days').format('MM-DD-YY');
                                                    //     if (moment().format('MM-DD-YY') === endDate) {
                                                    //         setcustomStartEvaluation(true)
                                                    //         checkPopUp('Hr Manager', 7, 'EvaluationStartedHrManager', setHrEvaluationPopUp);
                                                    //     }
                                                    //     else if (moment().format('MM-DD-YY') > endDate) {
                                                    //         setcustomStartEvaluation(true)
                                                    //     }
                                                    // }

                                                }}
                                                className={tabClicked === 'orggoal' ? 'nav-link active px-0 font-15 tab-style bold-text rounded-0' : "nav-link px-0 font-15 tab-style bold-text rounded-0"}
                                                id="orggoal-tab"
                                                data-bs-toggle="pill"
                                                data-bs-target="#orggoal"
                                                type="button"
                                                role="tab"
                                                aria-controls="orggoal"
                                                aria-selected="false"
                                            >
                                                Organization Goal
                                            </button>
                                        </li>
                                    )}
                                </ul>
                                <ul className="nav float-end mt-2">
                                    <li className="nav-item d-flex align-items-center">
                                        <label className="text-blue font-12 medium-text label-text me-2 float-start ">Evaluation Period</label>
                                        <div className="btn-group mrp-monthdisplay semibold-text font-12" role="group" aria-label="Basic outlined example">
                                            <button onClick={() => { previousEvaluation('pre'); }} type="button" data-bs-toggle="tooltip" title="Previous Week" data-bs-placement="bottom" className="btn btn-outline-primary border-0 performance-flip-color"><img src="Images/eva-Left-arrow.svg" className="flip-arrow-size" /></button>
                                            {evaluationShow != {} ? (<button type="button" className="btn btn-outline-primary border-0 performance-flip-color semibold-text font-12">{moment(evaluationShow.startData).format('MMM, YYYY')}-{moment(evaluationShow.endDate).format('MMM, YYYY')}</button>) : null}
                                            <button onClick={() => { nextEvaluation('next'); }} type="button" data-bs-toggle="tooltip" title="Next Week" data-bs-placement="bottom" className="btn btn-outline-primary  border-0 performance-flip-color"><img src="Images/eva-Right-arrow.svg" className="flip-arrow-size" /></button>
                                        </div>
                                    </li>
                                    {userDetails.role !== 'Team Member' ? (
                                        <li>
                                            <div className="dropdown">
                                                <button
                                                    className="btn hive-btn-primary dropdown-toggle"
                                                    type="button"
                                                    id="dropdownMenuButton1"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <img src="/Images/add.svg" alt="add-arrow" className />{' '}
                                                    <span className="right-arrow">New Goal</span>
                                                </button>
                                                <ul className="dropdown-menu shadow border-0 w-100" aria-labelledby="dropdownMenuButton1">
                                                    <li
                                                        onClick={() => {
                                                            AssgignGoal('team');
                                                        }}
                                                    >
                                                        <a className="dropdown-item">Team Goal</a>
                                                    </li>
                                                    <li
                                                        onClick={() => {
                                                            AssgignGoal('individual');
                                                        }}
                                                    >
                                                        <a className="dropdown-item">Individual Goal</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                    ) : null}
                                </ul>
                            </div>
                            {/*goal tab ends here*/}
                            <div className="row my-3 mx-0">
                                <div className="tab-content px-0" id="pills-tabContent">

                                    {tabClicked === 'mygoal' || tabClicked === '' ? <MyGoal
                                        Evaluation={evaluationShow}
                                        EmployeeEvaluation={individualEvaluation}
                                        evaluationPeriodId={evaluationShow.id}
                                        Individual={individualGoal}
                                        Team={teamGoal}

                                    /> : null}

                                    {/*organization goal tab content starts here*/}
                                    <div className={tabClicked === 'orggoal' ? `tab-pane fade active show` : "tab-pane fade"} id="orggoal" role="tabpanel" aria-labelledby="orggoal-tab">
                                        {/*Accordian starts here*/}
                                        {userDetails.role == 'Manager' ? (
                                            <ManagerGoal customStartEvaluation={customStartEvaluation} evaluationShow={evaluationShow} evaluationPeriodId={evaluationShow.id} />
                                        ) : evaluationShow.id !== undefined ? (
                                            <OrganizationGoal customStartEvaluation={customStartEvaluation} evaluationPeriodId={evaluationShow.id} evaluationShow={evaluationShow} />
                                        ) : null}
                                        {/*Accordian ends here*/}
                                    </div>
                                    {/*organization goal tab content ends here*/}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> :
                <Loader isLoading={isLoading} />}
        </>
    );
}
